import type { Span, SpanProcessor } from '@opentelemetry/sdk-trace-base'

// The active store is known only after login, long after the tracer provider
// is built, so it cannot be a resource attribute. Instead every span started
// from then on carries it as a span attribute — never as part of a span name,
// which is what the gateway turns into metric series. Span attributes reach
// Tempo only, where `flowhub.store.id` is what makes "show me this store's slow
// checkout" a query rather than a hand-run search (INFRA-474 / INFRA-476).

type TelemetryContext = { storeId?: string }

let telemetryContext: TelemetryContext = {}

/** Set (or clear, with `{}`) the context stamped onto every new span. */
export const setTelemetryContext = (next: TelemetryContext) => {
  telemetryContext = { ...next }
}

export class TelemetryContextProcessor implements SpanProcessor {
  onStart(span: Span) {
    const { storeId } = telemetryContext
    if (storeId) span.setAttribute('flowhub.store.id', storeId)
  }

  onEnd() {}

  shutdown() {
    return Promise.resolve()
  }

  forceFlush() {
    return Promise.resolve()
  }
}
